import { Language } from '@infominds/react-native-components'

function getLocale(language: Language) {
  switch (language) {
    case 'de':
      return 'de-DE'
    case 'en':
      return 'en-US'
    case 'it':
      return 'it-IT'
    default:
      return 'en-US'
  }
}

export const PriceUtils = {
  formatPrice(price: number, language: Language, currency?: string | null) {
    const formatter = Intl.NumberFormat(getLocale(language), {
      style: 'currency',
      currency: 'EUR',
    })
    const formattedValue = formatter.format(price).replace('€', '').trim()
    if (!currency) return formattedValue
    return `${formattedValue} ${currency}`
  },
  getSeparators(language: Language) {
    const value = this.formatPrice(1000.0, language, null)
    return { thousands: value[1], decimal: value[5] }
  },
}
